/**
 * Per-tile-type default sizes (12-col grid units, `gridLayout.ts` §GRID_COLS)
 * — the single source of truth for every tile-creation path that lands a
 * tile WITHOUT a bespoke sizing step of its own. Stat (and note) default to
 * half the row height of chart/table/pivot: a single stat value doesn't need
 * a 4-row-tall footprint, so two stat tiles stack gap-free in the space one
 * used to occupy (see Docs/Dashboards.md § stat-tile density).
 *
 * Dep-free leaf (type-only import) so it is safe to import from BOTH the
 * renderer and the electron main process — mirrors the
 * `core/engines/databaseEngineIdToSqlEngine.ts` pattern; `types/dashboardTypes.ts`
 * is already imported directly from `electron/dashboards/*` (e.g.
 * `mcpDashboardTileMaterialize.ts`), so this module is safe alongside it.
 *
 * Producers on this map: `services/pinToDashboard.ts`, `services/starterPreflight.ts`,
 * `hooks/useDashboardAiTileAdd.ts` (Build-with-AI add path), and
 * `electron/dashboards/mcpDashboardTileMaterialize.ts` (S17 MCP tools).
 * `components/add-tile/AddTileDialog.tsx` still keeps its own local
 * `DEFAULT_SIZE` (out of scope for this change — owned by another
 * in-flight agent) but should adopt this map as a follow-up so there is
 * exactly one definition.
 */
import type { DashboardTileType } from '../types/dashboardTypes';

export const DEFAULT_TILE_SIZE: Record<DashboardTileType, { w: number; h: number }> = {
  chart: { w: 6, h: 4 },
  stat: { w: 3, h: 2 },
  table: { w: 6, h: 4 },
  pivot: { w: 6, h: 4 },
  map: { w: 6, h: 4 },
  note: { w: 4, h: 2 },
};
